
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";


// --------------------Part-5 Post API---------------------

export const PlantationDetailsPartFivePatchAPI = createAsyncThunk("PlantationDetailsPartFivePatch", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        T_BeneficiaryPlantationDetailsID,
        AnyFertilizers_M_IndicatorID,
        WeedPractices_M_IndicatorID,
        DiseasesObserved_M_IndicatorID,
        ObservedDwarfism_M_IndicatorID,
        Labour_For_Plantation_M_IndicatorID,
        TimeForPlantation,
        DailyLabourCharges,
        M_TableUserMasterID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("FinancialYearID", FinancialYearID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("AnyFertilizers_M_IndicatorID", AnyFertilizers_M_IndicatorID);
    formdata.append("WeedPractices_M_IndicatorID", WeedPractices_M_IndicatorID);
    formdata.append("DiseasesObserved_M_IndicatorID", DiseasesObserved_M_IndicatorID);
    formdata.append("ObservedDwarfism_M_IndicatorID", ObservedDwarfism_M_IndicatorID);
    formdata.append("Labour_For_Plantation_M_IndicatorID", Labour_For_Plantation_M_IndicatorID);
    formdata.append("TimeForPlantation", TimeForPlantation);
    formdata.append("DailyLabourCharges", DailyLabourCharges);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryPlantationDetails_5_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantationDetailsPartFivePatchSlice = createSlice({
    name: "PlantationDetailsPartFivePatch",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartFivePatchAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantationDetailsPartFivePatchAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantationDetailsPartFivePatchAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const PlantationDetailsPartFivePatchReducer = PlantationDetailsPartFivePatchSlice.reducer


// --------------------Fertilizer  Post API---------------------

export const FertilizerPostAPI = createAsyncThunk("FertilizerPost", async ({ data }) => {
    const {

        T_BeneficiaryPlantationDetailsID,
        WhichFertilizer,
        Frequency_For_Fertilizer_M_IndicatorID,
        M_TableUserMasterID,
        token,
        // handleIsFenchData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("WhichFertilizer", WhichFertilizer);
    formdata.append("Frequency_For_Fertilizer_M_IndicatorID", Frequency_For_Fertilizer_M_IndicatorID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_FertilizerSoil_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                // handleIsFenchData()
                toastSuccess("Data Update Successfully")
            } else {
                toastError(result.message)
            }
            return result
        })
})

const FertilizerPostSlice = createSlice({
    name: "FertilizerPost",
    initialState: {
        isPostLoading2: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(FertilizerPostAPI.pending, (state, action) => {
            state.isPostLoading2 = true;
        });
        builder.addCase(FertilizerPostAPI.fulfilled, (state, action) => {
            state.isPostLoading2 = false;
            state.PostData = action.payload;
        });
        builder.addCase(FertilizerPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading2 = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const FertilizerPostReducer = FertilizerPostSlice.reducer

// --------------------growth or dwarfism API---------------------

export const GrowthDwarfismPostAPI = createAsyncThunk("GrowthDwarfismPost", async ({ data }) => {
    const {

        T_BeneficiaryPlantationDetailsID,
        PlantsGrowth,
        M_TableUserMasterID,
        token,
        // handleIsFenchData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("PlantsGrowth", PlantsGrowth);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Post_APK_T_BeneficiaryPlantationDetails_StuntedGrowthDwarfism_Insert`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                // handleIsFenchData()
                toastSuccess("Data Update Successfully")
            } else {
                toastError(result.message)
            }
            return result
        })
})

const GrowthDwarfismPostSlice = createSlice({
    name: "GrowthDwarfismPost",
    initialState: {
        isPostLoading3: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GrowthDwarfismPostAPI.pending, (state, action) => {
            state.isPostLoading3 = true;
        });
        builder.addCase(GrowthDwarfismPostAPI.fulfilled, (state, action) => {
            state.isPostLoading3 = false;
            state.PostData = action.payload;
        });
        builder.addCase(GrowthDwarfismPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading3 = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const GrowthDwarfismPostReducer = GrowthDwarfismPostSlice.reducer

// ------------------------------plantation Techniques Delete API -------------------------------

export const FertilizerDeleteAPI = createAsyncThunk("FertilizerDelete", async ({ data }) => {
    const {
        T_BeneficiaryPlantationDetailsID,
        M_TableUserMasterID,
        Flag,
        token,
        handleIsFertilizerData,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryPlantationDetailsID", T_BeneficiaryPlantationDetailsID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    formdata.append("Flag", Flag);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/Web_T_BeneficiaryPlantationDetails_5_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsFertilizerData()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const FertilizerDeleteSlice = createSlice({
    name: "FertilizerDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(FertilizerDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(FertilizerDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(FertilizerDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const FertilizerDeleteReducer = FertilizerDeleteSlice.reducer

